import { render, staticRenderFns } from "./MyBooks.vue?vue&type=template&id=077963ac&scoped=true&"
import script from "./MyBooks.vue?vue&type=script&lang=js&"
export * from "./MyBooks.vue?vue&type=script&lang=js&"
import style0 from "./MyBooks.vue?vue&type=style&index=0&id=077963ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077963ac",
  null
  
)

export default component.exports